<template>
    <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
      <font-awesome-icon icon="recycle"/>&nbsp;{{ $t('extend') }}
      <b-modal v-model="showForm" :title="$t('extend')" no-close-on-backdrop no-enforce-focus size="xl">
      <div class="modal-content">
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-md">
                <div class="alert alert-warning">
                  ĐIỀU KIỆN ĐỂ TẠO ĐƯỢC ĐƠN HÀNG GIA HẠN
                  <ul>
                    <li>Đã/đang sử dụng gói dịch vụ không phải là Flex</li>
                    <li>Số người dùng muốn gia hạn cần không nhỏ hơn số tài khoản hiện tại đang hoạt động</li>
                    <li>Số dư trong tài khoản trừ đi số tiền cần thanh toán lớn hơn hạn mức</li>
                  </ul>
                  CÁC TRƯỜNG HỢP KHÔNG THỰC HIỆN SỚM QUÁ 3 NGÀY TRƯỚC KHI HẾT HẠN
                  <ul>
                    <li>Số tài khoản muốn gia hạn lớn hơn số người dùng tối đa hiện tại</li>
                    <li>Gói dịch vụ mới có giá tiền cao hơn gói dịch vụ cũ</li>
                  </ul>
                </div>
                <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"></client-select>
                <div v-if="getClientLoading" class="text-center">
                  <b-spinner></b-spinner>
                </div>
                <div v-else-if="client">
                  <p>
                    <span>{{ $t('sales') }}</span>:
                    <b>{{ client.populatedSales ? client.populatedSales.name : $t('noSales') }}</b>
                  </p>
                  <p>
                    <span>{{ $t('currentPlan') }}</span>:
                    <b v-if="getPlanLoading">
                      <b-spinner small></b-spinner>
                    </b>
                    <b v-else-if="currentPlanName">{{ currentPlanName }}</b>
                    <b v-else>{{ $t('noCurrentPlanFound') }}</b>
                  </p>
                  <p>
                    <span>{{ $t('userPrice') }}</span>:
                    <b v-if="getPlanLoading">
                      <b-spinner small></b-spinner>
                    </b>
                    <b v-else-if="currentPlanUserPrice">{{ currentPlanUserPrice | numFormat }}</b>
                    <b v-else>{{ $t('noCurrentPlanFound') }}</b>
                  </p>
                  <p><span>{{ $t('currentUserLimit') }}</span>: <b>{{ client.userLimit }}</b></p>
                  <p><span>{{ $t('currentUserCount') }}</span>: <b>{{ client.userCount }}</b></p>
                  <p><span>{{ $t('expireTime') }}</span>: <b>{{ client.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b></p>
                  <p><span>{{ $t('creditBalance') }}</span>: <b>{{ client.creditBalance | numFormat }}</b></p>
                  <p><span>{{ $t('creditLimit') }}</span>: <b>{{ client.creditLimit | numFormat }}</b></p>
                </div>
              </div>
              <div class="col-md">
                <form-select :label="$t('planToExtend')" attribute="plan" :model="formModel" :errors="formErrors" :options="planOptions" :disabled="!client"></form-select>
                <p v-if="newPlanUserPrice">
                  <span>{{ $t('newUserPrice') }}</span>:
                  <b>{{ newPlanUserPrice | numFormat }}</b>
                </p>
                <form-input :label="$t('numberOfUser')" attribute="userLimit" :model="formModel" :errors="formErrors"></form-input>
                <form-radio-group :label="$t('expireTimeInputOption')" attribute="expireTimeInputOption" :model="formModel" :options="[
                    {value: 'inputMonthCount', text: $t('inputMonthCount')},
                    {value: 'inputExpireTime', text: $t('inputExpireTime')}
                ]"></form-radio-group>
                <form-input :label="$t('monthCount')" attribute="monthCount" :model="formModel" :errors="formErrors" :disabled="formModel.expireTimeInputOption !== 'inputMonthCount'"></form-input>
                <form-date-time :label="$t('extendTo')" attribute="expireTime" :model="formModel" :errors="formErrors" :disabled="formModel.expireTimeInputOption !== 'inputExpireTime'"></form-date-time>
                <form-input :label="$t('discount')" attribute="discountAmount" :model="formModel" :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfDayGifted')" attribute="numberOfDayGifted" :model="formModel" :errors="formErrors"></form-input>
                <form-input :label="$t('numberOfUserGifted')" attribute="numberOfUserGifted" :model="formModel" :errors="formErrors"></form-input>
                <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
              </div>
            </div>
          </form>
          <template v-if="client">
            <hr class="is-primary">
            <div class="row">
              <div class="col-7 col-md-6 offset-md-2 text-right">{{ $t("expireTime") }}:</div>
              <div class="col-5 col-md-4 text-right">
                <b v-if="finalExpireTime">{{ finalExpireTime | moment('DD/MM/YYYY HH:mm:ss') }}</b>
                <b v-else>{{$t('undefined')}}</b>
              </div>
            </div>
            <div class="row">
              <div class="col-7 col-md-6 offset-md-2 text-right">{{ $t("total") }}:</div>
              <div class="col-5 col-md-4 text-right">
                <b>{{ total | numFormat }}</b>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button :disabled="!formModel.client || !formModel.userLimit || !formModel.monthCount || !currentPlanUserPrice || !currentPlanName || !['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)"
                class="btn btn-primary float-right" @click="extend()">
          {{ $t('extend') }}
        </button>
      </template>
    </b-modal>
    </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import moment from "moment-timezone";

export default {
  components: {ClientSelect},
  mixins: [CRUD],
  props: ['clientId'],
  data: function () {
    return {
      service: '/plan-order',
      defaultFormModel: {
        plan: null,
        userLimit: 0,
        monthCount: 0,
        client: this.clientId ? this.clientId : null,
        discountAmount: 0,
        numberOfDayGifted: 0,
        numberOfUserGifted: 0,
        expireTimeInputOption: 'inputMonthCount',
        expireTime: null
      },
      client: null,
      currentPlanName: null,
      currentPlanUserPrice: 0,
      newPlanUserPrice: 0,
      getClientLoading: false,
      getPlanLoading: false,
      plans: [],
      planOptions: [{value: null, text: this.$t('choosePlan')}],
      finalExpireTime: null
    }
  },
  methods: {
    open: function () {
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
      if (this.clientId) {
        this.getClient()
      }
    },
    extend() {
      let loader = this.$loading.show();
      let url = '/extend';
      this.$service({url: this.service + url, method: 'post', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('extended'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('planOrder');
          this.$bus.$emit('loadClient');
          this.showForm = false;
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    getClient() {
      this.$service.get('/client/' + this.formModel.client).then(response => {
        if (response) {
          this.client = response.data;
        }
      }).finally(() => {
        this.getClientLoading = false;
      })
    },
    getPlans() {
      if (this.client) {
        this.getPlanLoading = true;
        this.$service.get('/plan/', {
          params: {
            page: 1,
            pageSize: 100,
            active: true,
          }
        }).then(response => {
          if (response && response.data && response.data.docs) {
            this.plans = response.data.docs;
            this.planOptions = [{value: null, text: this.$t('choosePlan')}];
            this.plans.forEach(p => {
              if (!p.unlimitedUser) {
                this.planOptions.push({
                  value: p._id, text: p.name
                })
              }
            });
          }
        }).then(() => {
          let currentPlan = this.plans.find(p => p._id === this.client.plan);
          if (currentPlan) {
            this.currentPlanName = currentPlan.name;
            this.currentPlanUserPrice = currentPlan.userPrice;
            if (this.planOptions.includes(o => o.value === currentPlan._id)) {
              this.formModel.plan = currentPlan._id;
            }
          }
        }).finally(() => {
          this.getPlanLoading = false;
        })
      }
    }
  },
  computed: {
    total () {
      return this.newPlanUserPrice * this.formModel.monthCount * this.formModel.userLimit - this.formModel.discountAmount
    },
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (this.showForm && val) {
          this.getClientLoading = true;
          this.getPlanLoading = true;
          this.getClient();
        } else {
          this.client = null
        }
      }
    },
    "formModel.plan": {
      handler(val) {
        if (this.showForm && val) {
          let selectedPlan = this.plans.find(p => p._id === val);
          if (selectedPlan) {
            this.newPlanUserPrice = selectedPlan.userPrice;
          }
        } else {
          this.newPlanUserPrice = 0;
        }
      }
    },
    "client": {
      handler(val) {
        this.currentPlanName = null;
        this.currentPlanUserPrice = 0;
        if (val) {
          this.getPlans();
        } else {
          this.getClientLoading = false;
          this.getPlanLoading = false;
        }
      }
    },
    "formModel.monthCount": {
      handler(val) {
        if (this.showForm && val && this.formModel.expireTimeInputOption === 'inputMonthCount') {
          let timezone = this.client && this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
          let start = this.client.expireTime > Date.now() ? this.client.expireTime : moment(Date.now()).tz(timezone).endOf('day');
          this.formModel.expireTime = moment(start).add(this.formModel.monthCount, 'month');
          this.finalExpireTime = moment(this.formModel.expireTime).tz(timezone).endOf('day');
          if (this.formModel.numberOfDayGifted) {
            this.finalExpireTime = moment(this.formModel.expireTime).add(this.formModel.numberOfDayGifted, 'day')
          }
        }
      }
    },
    "formModel.expireTime": {
      handler(val) {
        if (this.showForm && val && this.formModel.expireTimeInputOption === 'inputExpireTime') {
          let timezone = this.client && this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
          let start = this.client.expireTime > Date.now() ? this.client.expireTime : moment(Date.now()).endOf('day');
          let end = moment(this.formModel.expireTime).tz(timezone).endOf('day');
          this.formModel.monthCount = Number(Math.round(moment(end).diff(moment(start), 'months', true)+ 'e1') + 'e-1');
          this.finalExpireTime = end;
          if (this.formModel.numberOfDayGifted) {
            this.finalExpireTime = moment(end).add(this.formModel.numberOfDayGifted, 'day')
          }
        }
      }
    },
    "formModel.numberOfDayGifted": {
      handler(val) {
        if (val >= 0 && Number.isInteger(Number(val)) && this.formModel.expireTime) {
          let timezone = this.client && this.client.timezone ? this.client.timezone : 'Asia/Ho_Chi_Minh';
          this.finalExpireTime = moment(this.formModel.expireTime).tz(timezone).endOf('day').add(this.formModel.numberOfDayGifted, 'day');
        } else {
          this.finalExpireTime = null;
        }
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        extend: "Gia hạn",
        currentPlan: "Gói dịch vụ hiện tại",
        currentUserLimit: "Số người dùng tối đa hiện tại",
        expireTime: "Ngày hết hạn",
        creditBalance: "Số dư trong tài khoản",
        creditLimit: "Hạn mức tài khoản",
        numberOfUser: "Số người dùng",
        monthCount: "Số tháng muốn gia hạn",
        discount: "Giảm giá",
        numberOfDayGifted: 'Số ngày tặng thêm',
        numberOfUserGifted: 'Số user tặng thêm',
        note: "Ghi chú",
        newExpireTime: "Gia hạn đến",
        userPrice: "Giá/ người dùng",
        total: "Thành tiền",
        sales: 'Nhân viên sales',
        noSales: 'Không có nhân viên sales',
        account: 'Nhân viên account',
        noAccount: 'Không có nhân viên account',
        supervisor: 'Trưởng nhóm',
        chooseSupervisor: 'Chọn trưởng nhóm',
        manager: 'Trưởng phòng',
        chooseManager: 'Chọn trưởng phòng',
        currentUserCount: 'Số tài khoản hiện tại đang hoạt động',
        extended: 'Gia hạn thành công',
        noSupervisorFound: 'Không tìm thấy trưởng nhóm',
        noManagerFound: 'Không tìm thấy trưởng phòng',
        noCurrentPlanFound: 'Không tìm thấy thông tin gói dịch vụ hiện tại',
        plan: 'Gói dịch vụ',
        choosePlan: 'Chọn gói dịch vụ muốn gia hạn',
        newUserPrice: 'Giá/ người dùng',
        planToExtend: 'Gói dịch vụ muốn gia hạn',
        expireTimeInputOption: 'Nhập thời gian gia hạn',
        inputMonthCount: 'Nhập số tháng muốn gia hạn',
        inputExpireTime: 'Nhập ngày hết hạn',
        extendTo: 'Gia hạn tới'
      },
      en: {
        extend: "Extend",
        currentPlan: "Current plan",
        currentUserLimit: "Current user limit",
        expireTime: "Expire time",
        creditBalance: "Credit balance",
        creditLimit: "Credit limit",
        numberOfUser: "Number of user",
        monthCount: "Number of month to extend",
        discount: "Discount",
        numberOfDayGifted: 'Number of day to extend',
        numberOfUserGifted: 'Number of user gifted',
        note: "Note",
        newExpireTime: "Extend to",
        userPrice: "Price/ user",
        total: "Total",
        sales: 'Sales person',
        noSales: 'No sales person',
        account: 'Account',
        noAccount: 'No sales account',
        supervisor: 'Supervisor',
        chooseSupervisor: 'Choose supervisor',
        manager: 'Manager',
        chooseManager: 'Choose manager',
        currentUserCount: 'Number of current active user',
        extended: 'Extended!',
        noSupervisorFound: 'No supervisor found',
        noManagerFound: 'No manager found',
        noCurrentPlanFound: 'Current plan not found',
        plan: 'Plan',
        choosePlan: 'Choose plan to extend',
        newUserPrice: 'User price',
        planToExtend: 'Plan to extend',
        expireTimeInputOption: 'Expire time input option',
        inputMonthCount: 'Input month count',
        inputExpireTime: 'Input expire time',
        extendTo: 'Extend to'
      }
    }
  }
}
</script>